import { render, staticRenderFns } from "./peopleInEdutalk-page.vue?vue&type=template&id=3f71a082&scoped=true"
import script from "./peopleInEdutalk-page.vue?vue&type=script&lang=js"
export * from "./peopleInEdutalk-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f71a082",
  null
  
)

export default component.exports